/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useParams } from 'react-router-dom';
import { Constants } from '@pwc/pwc-deals-web-common';
import { useSelector } from 'react-redux';
import { getStructuredAnalysisViewDocumentsWithContentForDocument } from 'common/engine/reducers/structuredAnalysisViewSlice';
import { VersioningProps } from '../types';
import VersioningMFE from '../VersioningMFE';

const DocumentCodes: Record<string, string> = {
  'quality-of-earnings': Constants.QUALITY_OF_EARNINGS,
  'net-working-capital': Constants.NET_WORKING_CAPITAL,
  'debt-debt-like': Constants.DEBT_AND_DEBT_LIKE,
};

export const StructuredAnalysisVersioning = (props: VersioningProps) => {
  const { entityType } = props;
  const documentCode = DocumentCodes[String(entityType)];
  const analysis = useSelector(
    getStructuredAnalysisViewDocumentsWithContentForDocument(documentCode)
  );

  if (analysis) {
    const {
      content: { contentThreadId },
    } = analysis;
    const { projectId } = useParams<{
      projectId: string;
    }>();
    return (
      <VersioningMFE
        {...props}
        contentThreadId={contentThreadId}
        projectId={projectId}
      />
    );
  }
  return <></>;
};
